import { HttpClient } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { environment } from "src/environments/environment";
import { BucketMemberPayload, BucketMemberResponse } from "src/app/content/pages/crm/models/crm";

@Injectable({ providedIn: "root" })
export class BucketService {
  private readonly http = inject(HttpClient);

  addBucketMember(payload: BucketMemberPayload): Observable<BucketMemberResponse> {
    return this.http.post<BucketMemberResponse>(
      `${environment.apiUrl}api/clients/bucketregistrymember/`,
      payload
    );
  }

  removeBucketMember(id: string): Observable<void> {
    return this.http.delete<void>(
      `${environment.apiUrl}api/clients/bucketmember/${id}/`
    );
  }
}
